import React from 'react';

import './TableRow.css'

const tableRow = (props) => {
  return (
    <tr className="TableRow" onClick={props.click}>
      {props.children}
    </tr>
  );
}

export default tableRow;



// WEBPACK FOOTER //
// ./src/Components/Table/TableRow/TableRow.js